export const cilFilterFrames = ["24 24","<path d='M18 4.875h-12v11.068h12zM16.5 14.443h-9v-8.068h9z'></path><path d='M20.625 0.75h-17.25c-0.828 0.001-1.499 0.672-1.5 1.5v16.318c0.001 0.828 0.672 1.499 1.5 1.5h5.132l3.493 3.493 3.493-3.493h5.132c0.828-0.001 1.499-0.672 1.5-1.5v-16.318c-0.001-0.828-0.672-1.499-1.5-1.5h-0zM20.625 18.568h-5.754l-2.871 2.871-2.871-2.871h-5.754v-16.318h17.25z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-filter-frames.js
// module id = null
// module chunks = 